import React from "react";
import { get } from "lodash";

import { useDrop } from "react-dnd";

import Grid from "@material-ui/core/Grid";

import { dragTypes } from "../../../constants/dragTypes";
import colors from "../../../assets/style/colors";
import AddOccurrence from "../AddOccurrence/AddOccurrence";

const SchedulerCalendarTimeSlot = (props) => {
  const { date, slot, timeSlots, width, height, refresh } = props;
  const [openAdd, setOpenAdd] = React.useState(false);

  const [{ canDrop, isOver }, drop] = useDrop(() => ({
    accept: dragTypes.OCCURRENCE,
    drop: () => ({ slot, date }),
    collect: (monitor) => ({
      isOver: monitor.isOver(),
      canDrop: monitor.canDrop(),
    }),
  }));

  const isActive = canDrop && isOver;

  return (
    <Grid
      item
      ref={drop}
      style={{
        width: width,
        height: height,
        border: isActive ? `1px dashed ${colors.primary}` : "none",
      }}
      onDoubleClick={() => setOpenAdd(true)}
    >
      {openAdd && (
        <AddOccurrence
          open={openAdd}
          setOpen={setOpenAdd}
          timeSlots={timeSlots}
          initialDate={date}
          initialTimeSlot={get(slot, ["id"])}
          refresh={refresh}
        />
      )}
      {props.children}
    </Grid>
  );
};

export default SchedulerCalendarTimeSlot;
